export default __webpack_public_path__ + "static/media/cursorPoint.d51df24b.svg";